import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsThree2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBarsThree2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 5H22V7H2V5ZM2 11H22V13H2V11ZM2 17H12V19H2V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarsThree2;
